import script from "./MailBody.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBody.vue?vue&type=script&setup=true&lang=js"

import "./MailBody.vue?vue&type=style&index=0&id=fa9530b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa9530b6"]])

export default __exports__